import React from "react";
import { Box } from "@mui/material";
import { Hub, Inventory2, LocalShipping, Analytics } from "@mui/icons-material";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const floatingIcons = [
  {
    icon: <Hub sx={{ fontSize: 24 }} />,
    position: {
      top: "5px",
      left: "20px",
    },
  },
  {
    icon: <Inventory2 sx={{ fontSize: 24 }} />,
    position: {
      top: "12%",
      right: "12px",
    },
  },
  {
    icon: <LocalShipping sx={{ fontSize: 24 }} />,
    position: {
      bottom: "10%",
      left: "-5px",
    },
  },
  {
    icon: <Analytics sx={{ fontSize: 24 }} />,
    position: {
      bottom: "10px",
      right: "8%",
    },
  },
];

export default function FloatingIcons() {
  return (
    <>
      {floatingIcons.map((item, index) => (
        <MotionBox
          key={index}
          animate={{
            y: [0, -14, 0],
            rotate: [0, 2, -2, 0],
            opacity: [0.45, 1, 0.45],
          }}
          transition={{
            duration: 5 + index,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          sx={{
            position: "absolute",
            ...item.position,

            width: 52,
            height: 52,

            display: {
              xs: "none",
              md: "flex",
            },

            alignItems: "center",
            justifyContent: "center",

            borderRadius: "18px",

            // 40% visible effect
            opacity: 0.4,

            background: "rgba(255,255,255,0.6)",
            backdropFilter: "blur(10px)",

            color: "#143c7c",

            border: "1px solid rgba(8,45,99,0.06)",

            boxShadow: "0 12px 30px rgba(0,0,0,0.06)",

            zIndex: 1,
          }}
        >
          {item.icon}
        </MotionBox>
      ))}
    </>
  );
}
